/**
 * Text reverse — pure, deterministic text reversal.
 * Safe to render server-side.
 */

export type ReverseMode = "characters" | "words" | "lines";

export function reverseText(text: string, mode: ReverseMode): string {
  if (mode === "characters") {
    // Spread iterates by Unicode code point, so emoji / astral chars survive.
    return [...text].reverse().join("");
  }
  if (mode === "lines") {
    return text.split("\n").reverse().join("\n");
  }
  // words — splits on runs of whitespace, so internal whitespace is
  // normalized to single spaces in the result.
  const trimmed = text.trim();
  if (trimmed === "") return "";
  return trimmed.split(/\s+/).reverse().join(" ");
}
